// The "Compliance" pill of the mobile vehicle cards and the sections of its modal, from one
// by-cars row. Reuses the helpers of the desktop columns so both show the same values. Plain
// module with no Vue, so it runs under `node --test`. Labels are i18n keys.
import { dueDateText } from "../Acceptance/deadlines.mjs";
import { listChips } from "../Acceptance/praView.mjs";
import { listCell } from "../Workshop/workshopView.mjs";
import { releasedChip } from "../Waste/carBodyRelease.mjs";

const STATUS_COLORS = {
  not_started: "grey",
  draft: "amber-darken-3",
  confirmed: "green",
};

// row: the by-cars row of the car, or undefined (no dossier). acceptance: show the acceptance
// status (the inventory; Storico shows only PRA and depollution).
// Returns { color, first, second, empty, sections }:
// - color: the dot, from the acceptance status;
// - first: the chips of the pill's first line (acceptance status, then the PRA chips);
// - second: the depollution chip of the second line, or null;
// - released: the grey "Carcassa rilasciata" chip (waste on, Stage 6 slice 4), or null;
// - empty: nothing to show (the pill shows "—");
// - sections: [{ id, titleKey, chips, deadlines?, dueDate? }] for the modal.
export function complianceSummary(
  row,
  {
    acceptance = true,
    praEnabled = false,
    workshopEnabled = false,
    wasteEnabled = false,
  } = {},
) {
  const status = row && STATUS_COLORS[row.status] ? row.status : "not_started";
  const statusChip = {
    key: `acceptance.status.${status}`,
    color: STATUS_COLORS[status],
  };
  const praChips = praEnabled ? listChips(row && row.pra) : [];
  const cell = workshopEnabled ? listCell(row) : { chip: null, dueDate: "" };
  const released = workshopEnabled && wasteEnabled ? releasedChip(row) : null;

  const sections = [];
  if (acceptance) {
    const depollution = dueDateText(row, "depollution");
    sections.push({
      id: "acceptance",
      titleKey: "acceptance.list.column",
      chips: [statusChip],
      deadlines: depollution
        ? {
            depollution,
            deregistration: dueDateText(row, "deregistrationRequest"),
          }
        : null,
    });
  }
  if (praEnabled) {
    sections.push({
      id: "pra",
      titleKey: "acceptance.pra.title",
      chips: praChips,
    });
  }
  if (workshopEnabled) {
    sections.push({
      id: "depollution",
      titleKey: "acceptance.depollution.column",
      chips: [cell.chip, released].filter(Boolean),
      dueDate: cell.dueDate,
    });
  }

  const first = [...(acceptance ? [statusChip] : []), ...praChips];
  return {
    color: statusChip.color,
    first,
    second: cell.chip,
    released,
    empty: !first.length && !cell.chip && !released,
    sections,
  };
}
